export const messages = {
    "wrh-dashboard.nav-menu.item.resources": "资源",
    "wrh-dashboard.nav-menu.item.shared": "共享",
    "wrh-dashboard.nav-menu.item.backups": "备份",
    "wrh-dashboard.nav-menu.item.archives": "存档",
    "wrh-dashboard.nav-menu.item.sync": "同步",
    "wrh-dashboard.nav-menu.item.mobile": "手机",
    "wrh-dashboard.nav-menu.item.account": "帐户",
    "wrh-dashboard.search.input.hint": "搜索",
    "wrh-dashboard.search.label.breadcrumb": "搜索结果",
    "wrh-dashboard.search.message.empty": "没有搜索到匹配的项目",
    "wrh-dashboard.side-bar.selected.title:plural": "{count} 个项目已选定 | {count} 个项目已选定",
    "wrh-dashboard.side-bar.backup-type.entire-pc": "整个 PC",
    "wrh-dashboard.side-bar.backup-type.entire-mac": "整个 Mac",
    "wrh-dashboard.side-bar.backup-type.disk": "磁盘与分区",
    "wrh-dashboard.side-bar.backup-type.file": "文件与文件夹",
    "wrh-dashboard.side-bar.backup-type.notarized": "公证的文件和文件夹",
    "wrh-dashboard.side-bar.backup-type.sync": "同步",
    "wrh-dashboard.side-bar.backup-type.archiving": "存档",
    "wrh-dashboard.space-indicator.label.left": "{spaceFree} 剩余量",
    "wrh-dashboard.space-indicator.label.used": "{usedSpace} 已用量",
    "wrh-dashboard.space-indicator.label.unlimited": "无限制",
    "wrh-dashboard.backups-table.column.name": "名称",
    "wrh-dashboard.backups-table.column.size": "大小",
    "wrh-dashboard.backups-table.column.version": "上一个版本",
    "wrh-dashboard.backups-table.action.cleanup": "清理",
    "wrh-dashboard.backups-table.action.download-tool": "下载",
    "wrh-dashboard.backups-table.action.delete": "删除",
    "wrh-dashboard.backups-table.action.downloads": "下载",
    "wrh-dashboard.backups-table.message.no-backups": "云中尚未有备份",
    "wrh-dashboard.backups-table.message.no-archives": "云中尚未有存档",
    "wrh-dashboard.backups-table.message.no-syncs": "云中尚未同步",
    "wrh-dashboard.backups-sidebar.label.size": "大小",
    "wrh-dashboard.backups-sidebar.label.type": "类型",
    "wrh-dashboard.backups-sidebar.label.version": "上一个版本",
    "wrh-dashboard.content-table.column.name": "名称",
    "wrh-dashboard.content-table.column.versions": "版本",
    "wrh-dashboard.content-table.column.volumes": "卷标",
    "wrh-dashboard.content-table.column.path": "路径",
    "wrh-dashboard.content-table.column.size": "大小",
    "wrh-dashboard.content-table.column.version": "上一个版本",
    "wrh-dashboard.content-table.action.notary-verify": "验证",
    "wrh-dashboard.content-table.action.notary-get-crt": "获取证书",
    "wrh-dashboard.content-table.action.asign": "发送以签名",
    "wrh-dashboard.content-table.action.versions": "版本",
    "wrh-dashboard.content-table.action.restore": "下载",
    "wrh-dashboard.content-table.action.share": "共享链接",
    "wrh-dashboard.content-table.label.size": "大小",
    "wrh-dashboard.content-table.label.created": "创建时间",
    "wrh-dashboard.content-table.label.modified": "修改时间",
    "wrh-dashboard.content-table.message.empty-folder": "此文件夹为空",
    "wrh-dashboard.password-dialog-box.title.backup": "加密备份",
    "wrh-dashboard.password-dialog-box.title.archive": "加密存档",
    "wrh-dashboard.password-dialog-box.message.backup": "请指定备份 {displayName} 的访问密码",
    "wrh-dashboard.password-dialog-box.message.archive": "请指定存档 {displayName} 的访问密码",
    "wrh-dashboard.password-dialog-box.hint.password": "密码",
    "wrh-dashboard.password-dialog-box.message.invalid-password": "密码不正确",
    "wrh-dashboard.download-tool-dialog-box.message.title": "下载云备份",
    "wrh-dashboard.download-tool-dialog-box.message.first-header": "要从备份中下载文件或文件夹，请执行以下操作:",
    "wrh-dashboard.download-tool-dialog-box.message.first-paragraph": "单击备份名称、在备份中选择文件或文件夹，然后单击右侧面板中的“下载”。",
    "wrh-dashboard.download-tool-dialog-box.message.second-header": "要下载整个备份或备份集，请执行以下操作:",
    "wrh-dashboard.download-tool-dialog-box.message.second-paragraph": "使用 {toolName}.如果尚未下载该工具，则需要先下载它。",
    "wrh-dashboard.download-tool-dialog-box.message.tool-name": "Acronis Cloud Backup Download 工具",
    "wrh-dashboard.download-tool-dialog-box.message": "下载工具",
    "wrh-dashboard.download-tool-dialog-box.gotIt": "知道了",
    "wrh-dashboard.form.button.open": "打开",
    "wrh-dashboard.form.button.close": "关闭",
    "wrh-dashboard.form.button.cancel": "取消",
    "wrh-dashboard.form.button.continue": "继续",
    "wrh-dashboard.form.button.proceed": "继续",
    "wrh-dashboard.form.button.delete": "删除",
    "wrh-dashboard.form.button.done": "完成",
    "wrh-dashboard.form.button.retry": "重试",
    "wrh-dashboard.form.button.go-to-backups": "转到备份",
    "wrh-dashboard.delete-dialog-box.title.backup": "删除备份",
    "wrh-dashboard.delete-dialog-box.message.backup": "是否确定要从所有位置永久删除所选备份？所有备份数据将被销毁，无法还原。",
    "wrh-dashboard.delete-dialog-box.title.archive": "删除存档",
    "wrh-dashboard.delete-dialog-box.message.archive": "是否确定要从所有位置永久删除所选存档？所有存档数据将被销毁，无法还原。",
    "wrh-dashboard.delete-dialog-box.locked-error-message.backup": "已锁定备份，以确保数据一致性。请终止对备份的所有操作（例如，浏览、恢复、备份），然后重试。",
    "wrh-dashboard.delete-dialog-box.locked-error-message.archive": "存档已锁定，以确保数据一致性。请终止对存档的所有操作（例如，浏览、恢复、备份），然后重试。",
    "wrh-dashboard.cleanup-dialog-box.title": "{brandName} 清理",
    "wrh-dashboard.cleanup-dialog-box.checkbox.delete-versions-older-than": "删除低于以下版本的备份",
    "wrh-dashboard.cleanup-dialog-box.checkbox.delete-all-versions-except": "删除除以下外的所有旧的备份版本",
    "wrh-dashboard.cleanup-dialog-box.checkbox.delete-all-versions-recent-ones": "最近的版本",
    "wrh-dashboard.cleanup-dialog-box.combobox.time-unit.days": "天",
    "wrh-dashboard.cleanup-dialog-box.combobox.time-unit.months": "月",
    "wrh-dashboard.cleanup-dialog-box.combobox.time-unit.years": "年",
    "wrh-dashboard.cleanup-dialog-box.button.cleanup-now": "立即清理",
    "wrh-dashboard.cleanup-dialog-box.button.cleanup": "清理",
    "wrh-dashboard.cleanup-dialog-box.message": "您可以删除旧的备份版本，一次性释放 {brandName} 上的空间。这将不会更改 True Image 中设置的备份清理设置。",
    "wrh-dashboard.cleanup-dialog-box.message.cleanup-encrypted": "{encryptedBackupCount} 个备份（共 {totalBackupCount} 个备份）已加密。您必须输入密码才能清理它们。请分别进行清理。",
    "wrh-dashboard.cleanup-confirm-dialog-box.title": "清理",
    "wrh-dashboard.cleanup-confirm-dialog-box.message": "是否确定要删除此数据？您将无法撤消此操作。",
    "wrh-dashboard.cleanup-encrypted-dialog-box.title": "{brandName} 清理",
    "wrh-dashboard.cleanup-encrypted-dialog-box.message": "您的备份均加密。您必须输入密码才能清理它们。请分别进行清理。",
    "wrh-dashboard.cleanup-progress-dialog-box.title": "清理",
    "wrh-dashboard.cleanup-progress-dialog-box.message": "要查看清理操作的状态，请勿关闭此窗口。如果关闭窗口，清理操作将继续在后台模式下进行。",
    "wrh-dashboard.cleanup-progress-dialog-box.status": "{displayName} 正在清理 ...",
    "wrh-dashboard.cleanup-notification-dialog-box.title": "清理",
    "wrh-dashboard.cleanup-notification-dialog-box.message.success": "清理成功完成。云使用信息更新可能需要一些时间。",
    "wrh-dashboard.cleanup-notification-dialog-box.message.fail": "清理失败",
    "wrh-dashboard.cleanup-notification-dialog-box.message.box-locked": "正在进行备份，无法执行清理。请稍后再试。",
    "wrh-dashboard.cleanup-notification-dialog-box.message.wait": "将在后台模式下继续运行清理。请等待清理完成。",
    "wrh-dashboard.shared-content-table.column.name": "名称",
    "wrh-dashboard.shared-content-table.column.location": "位置",
    "wrh-dashboard.shared-content-table.column.source": "来源",
    "wrh-dashboard.shared-content-table.column.days": "天",
    "wrh-dashboard.shared-content-table.column.downloads": "下载",
    "wrh-dashboard.shared-content-table.column.shared": "共享于",
    "wrh-dashboard.shared-content-table.label.shared": "共享于",
    "wrh-dashboard.shared-content-table.label.backup": "来源",
    "wrh-dashboard.shared-content-table.action.share": "共享链接",
    "wrh-dashboard.shared-content-table.action.settings": "链接设置",
    "wrh-dashboard.shared-content-table.action.delete": "删除链接",
    "wrh-dashboard.shared-content-table.action.delete-selected": "删除链接",
    "wrh-dashboard.account-page.message.used-space": "{brandName}：{spaceFree} 已释放，共 {totalSpace}",
    "wrh-dashboard.account-page.message.used-unlimited-space": "{brandName}：无限空间",
    "wrh-dashboard.account-page.button.sign-out": "注销",
    "wrh-dashboard.account-page.button.clean-up": "清理",
    "wrh-dashboard.account-page.button.manage-subscription": "管理许可证",
    "wrh-dashboard.account-page.message.subscription.active": "您的 {brandName} 空间的许可证到期日期如下",
    "wrh-dashboard.account-page.message.subscription.trial": "{brandName} 试用有效期",
    "wrh-dashboard.account-page.message.subscription.expired": "您的 {brandName} 空间的许可证到期日期如下",
    "wrh-dashboard.account-page.message.worm-status.storage-full": "您的 {brandName} 存储空间已满。您无法将数据备份或存档至云。",
    "wrh-dashboard.account-page.message.worm-status.less-than": "可用空间少于 {percent}%。您即将无法使用 {brandName}。",
    "wrh-dashboard.notary.verify.view.status.downloading": "正在下载...",
    "wrh-dashboard.notary.verify.view.status.validating": "正在验证...",
    "wrh-dashboard.notary.verify.view.status.pending": "正在等待证书...",
    "wrh-dashboard.notary.verify.view.status.fail": "证书不匹配...",
    "wrh-dashboard.notary.verify.view.button.get-crt": "获取证书",
    "wrh-dashboard.notary.verify.view.file-info.name": "名称",
    "wrh-dashboard.notary.verify.view.file-info.signed-by": "签名者",
    "wrh-dashboard.notary.verify.view.file-info.date-backed-up": "备份日期",
    "wrh-dashboard.notary.verify.view.file-info.date-notarized": "公证日期",
    "wrh-dashboard.notary.verify.view.button.cancel": "取消",
    "wrh-dashboard.notary.verify.view.button.done": "完成",
    "wrh-dashboard.notary.warning.unsupported.browser.version": "不受支持的浏览器版本",
    "wrh-dashboard.versions-dialog-box.title": "{fileName} 的版本",
    "wrh-dashboard.asign-dialog-box.title": "发送以签名",
    "wrh-dashboard.asign-dialog-box.message": "文件版本已共享，但无人可以查看，因为没有此版本链接。转到 ASign 以添加签名者并共享链接。",
    "wrh-dashboard.asign-dialog-box.button.show-signed-file-details": "显示文件详细信息",
    "wrh-dashboard.shared-link-dialog-box.share-view.button.copy": "复制链接",
    "wrh-dashboard.shared-link-dialog-box.share-view.button.manage": "链接设置",
    "wrh-dashboard.shared-link-dialog-box.share-view.message": "获得此链接的任何人都可查看上一个版本的数据。",
    "wrh-dashboard.shared-link-dialog-box.share-view.label.shared": "共享于 {creationDate}",
    "wrh-dashboard.shared-link-dialog-box.share-view.notification.link-copied": "链接已复制",
    "wrh-dashboard.shared-link-dialog-box.share-view.notification.link-copy-error": "链接复制错误",
    "wrh-dashboard.shared-link-dialog-box.delete-view.title": "删除链接",
    "wrh-dashboard.shared-link-dialog-box.delete-view.message": "对于任何获得此链接的人而言，它将不再可用",
    "wrh-dashboard.shared-link-dialog-box.delete-selected-view.title": "删除链接",
    "wrh-dashboard.shared-link-dialog-box.delete-selected-view.message": "对于任何获得这些链接的人而言，它们将不再可用",
    "wrh-dashboard.shared-link-dialog-box.manage-view.title": "链接设置",
    "wrh-dashboard.shared-link-dialog-box.manage-view.button.delete": "删除链接",
    "wrh-dashboard.shared-link-dialog-box.manage-view.button.apply": "完成",
    "wrh-dashboard.shared-link-dialog-box.manage-view.input.hint.password": "密码",
    "wrh-dashboard.shared-link-dialog-box.manage-view.button.reset-password": "重置密码",
    "wrh-dashboard.shared-link-dialog-box.manage-view.caption.password-protection": "密码保护",
    "wrh-dashboard.shared-link-dialog-box.manage-view.message.protect-by-password": "使用密码保护此链接",
    "wrh-dashboard.shared-link-dialog-box.manage-view.caption.expiration": "到期",
    "wrh-dashboard.shared-link-dialog-box.manage-view.caption.download-limits": "下载限制",
    "wrh-dashboard.shared-link-dialog-box.manage-view.label.disable-in:plural": "在 {splitMarker} 天后禁用此链接 | 在 {splitMarker} 天后禁用此链接",
    "wrh-dashboard.shared-link-dialog-box.manage-view.label.disable-after:plural": "下载 {splitMarker} 次后禁用此链接 | 下载 {splitMarker} 次后禁用此链接",
    "wrh-dashboard.page-not-found.title": "未找到页面",
    "wrh-dashboard.page-not-found.message.main": "找不到您要查找的页面。",
    "wrh-dashboard.page-not-found.message.description": "链接可能已过期，或者键入的地址不正确。",
    "wrh-dashboard.page-not-found.message.error": "错误代码：404",
    "wrh-dashboard.server-error.title": "服务器不可用",
    "wrh-dashboard.server-error.message": "服务器暂时不可用。请稍后再试。",
    "wrh-dashboard.server-error.message.error": "错误代码：500"
};
